import { render, staticRenderFns } from "./TestimonialsComponent.vue?vue&type=template&id=f23a8400"
import script from "./TestimonialsComponent.vue?vue&type=script&lang=ts"
export * from "./TestimonialsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports